module.exports = __webpack_public_path__ + "img/Background_purple.ca5d72da.png";